import {axios} from '@/lib/axios';
import * as Config from "@/config";
import * as Common from "@/utils/common";
import {useLoadingStore} from "@/stores/loading";
import {useMessageModalStore} from '@/stores/message'

export function useCustomerExcelDownload() {
  
  const setLoading = useLoadingStore(state => state.setLoading);
  const setMessage = useMessageModalStore(state => state.setMessage);

  const downloadExcel = (response: any) => {
    // ファイル名を取得
    const encodedFilename = response.headers['x-filename'];
    const filename = encodedFilename ? decodeURIComponent(encodedFilename) : 'export.xlsx';

    // Blobを作成してダウンロード
    const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }

  // Excel出力
  function excelDownload(params: any) {
    setLoading(true);
    const postParams: { [key: string]: any; } = {
      'params': params,
    };
    axios.post('/api/v1/customers/exportCustomersList', postParams, {
         responseType: 'blob'
    })
      .then(response => {
        downloadExcel(response);
      })
      .catch(error => {
        setMessage(Config.MESSAGE_NO_E39);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return {
    excelDownload,
  }
}